import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../services/Constants/GlobalRoutes.jsx';
import JoinVodaPayClub from '../JoinVodaPayClub/JoinVodaPayClub.jsx';
import VodaPayClubPage from '../VodaPayClub/VodaPayClubPage.jsx';
import { SubscriptionDetailsContext } from '../../services/context/SubscriptionDetailsContext.js';
import Loading from '../../components/Loading/Loading.jsx';
import { CategoriesContext } from '../../services/context/CategoriesContext.js';

/**
 * @returns {JSX.Element} VodaPayClubRouter component
 */
export default function VodaPayClubRouter() {
  const subscriptionDetails = useContext(SubscriptionDetailsContext);
  const categories = useContext(CategoriesContext);
  const navigateTo = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!subscriptionDetails?.expiryDate) return; // wait for API
    setLoading(false);
  }, [subscriptionDetails]);

  if (loading) {
    return <Loading headerText='Loading...' />;
  }

  // Extract values from context
  const {
    isSubscribed,
    isEligibleToSubscribe,
    subscribedPlan,
    isSuspended,
  } = subscriptionDetails || {};

  // Handle Suspended/Grace Users → Redirect home
  if (isSuspended) {
    navigateTo(ROUTES.HOME);
    return null;
  }

  // NEW USER → show join page
  if (!isSubscribed && isEligibleToSubscribe) {
    return <JoinVodaPayClub />;
  }

  // ACTIVE USER (Subscribed or Cancelled-but-active)
  if (isSubscribed && (subscribedPlan?.isAutoRenewal === true || subscribedPlan?.isAutoRenewal === false)) {
    // Show club page only if categories are loaded
    if (categories.length > 0) {
      return <VodaPayClubPage />;
    }

    // If no categories yet, show loader
    return <Loading headerText='Loading categories...' />;
  }

  // Fallback — unknown state → redirect home
  navigateTo(ROUTES.HOME);
  return null;
}
